'use strict'
import React, { useContext, useEffect, useState, useRef } from 'react'

import 'primeflex/primeflex.css'
import 'primeicons/primeicons.css'
import 'primereact/resources/primereact.css'
import 'primereact/resources/themes/lara-light-indigo/theme.css'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { Button } from 'primereact/button'
import { Toast } from 'primereact/toast'
import { Toolbar } from 'primereact/toolbar'

import { api, request } from '../../../util/handlerRequestUtil'
import 'ag-grid-community/styles/ag-grid.css'
import 'ag-grid-community/styles/ag-theme-alpine.css'

import { Modal, Icon } from 'antd'

import { getMessage } from '../../../util/IntlMessages'
import { isAdmin } from '../../../util/profiles'
import { CustomerActionsPlanContext } from './CustomerActionsPlan'

import { useSelector } from 'react-redux'

import AlertIcon from '../../../assets/images/ico_erro.svg'

import moment from 'moment'

import FilterActionPlan from './ActionPlan.Filter'
import ModalActionPlan from '../../EibLocationsPlain/CreateEibLocationsPlain'
const { confirm, error } = Modal

const ListActionPlain = () => {
  const { filters, customerId, customer, loadCard, setLoadCard } = useContext(CustomerActionsPlanContext)
  const currentUser = useSelector((state) => state.auth.auth)
  const [locationId, setLocationId] = useState()
  const [isModalLocationPlainVisible, setIsModalLocationPlainVisible] = useState(false)
  const [change, setChange] = useState(false)
  const [formattedSafraAtual, setFormattedSafraAtual] = useState({})
  const [dentroPeriodo, setDentroPeriodo] = useState(false)
  const [eibLocations, setEibLocations] = useState()
  const [expandedRows, setExpandedRows] = useState(null)
  const toast = useRef(null)

  useEffect(() => {
    if (filters && filters.idSafra) {
      fetchValidadeConfigCalendario(filters)
    }
    fetchValidadeConfigCalendario(filters)
    getLocationsByCustomer()
  }, [filters, change, isModalLocationPlainVisible])

  async function fetchValidadeConfigCalendario(filtersData) {
    if (filtersData.idSafra) {
      const safraAtual = await api.findSafraByIdForActionPlan(filtersData.idSafra)
      const inicioSafra = moment(safraAtual.actionPlanningPeriodStartDate, 'DD/MM/YYYY').format('YYYY-MM-DD')
      const fimSafra = moment(safraAtual.actionPlanningPeriodEndDate, 'DD/MM/YYYY').format('YYYY-MM-DD')
      const now = moment().format('YYYY-MM-DD')
      setDentroPeriodo(now >= inicioSafra && now <= fimSafra)
      setFormattedSafraAtual(safraAtual)
    }
  }

  async function getLocationsByCustomer() {
    const locations = await request(api.getLocationsByCustomer(customerId, { idSafra: filters.idSafra }))
    const items = !isAdmin(currentUser)
      ? locations.filter((region) => region.regionId === currentUser.memberRegionId)
      : locations
    setEibLocations(items)
  }

  function setModalVisible(visible, locationId) {
    setIsModalLocationPlainVisible(visible)
    setLocationId(locationId)
    setLoadCard(!loadCard)
  }

  async function deleteLocationPlain(locationPlainId) {
    await request(api.deleteLocationPlain(locationPlainId))
    setLoadCard(!loadCard)
  }

  async function locationActionPlanPdf(location) {
    await api.exportActionPlanPdfByCustomer(customerId, {
      idSafra: filters.idSafra,
      regionId: location.regionId,
      districtId: location.districtId,
      locations: location.id
    })
  }

  function showAlertMessage(title, message) {
    error({
      title,
      icon: null,
      content: (
        <span style={{ marginLeft: !message ? 90 : 0 }}>
          {!message ? getMessage('SureToDelete?') : getMessage(message)}
        </span>
      ),
      cancelButtonProps: {
        style: {
          width: 148,
          borderColor: '#EE778F',
          color: '#EE778F'
        },
        type: 'ghost'
      },
      okButtonProps: {
        className: 'button-action',
        type: 'primary',
        style: {
          marginRight: -40
        }
      },
      okText: getMessage('label.ok')
    })
  }

  function showConfirm(onDeleteFunc, message) {
    confirm({
      title: <img src={AlertIcon} alt="" style={{ marginLeft: '42%' }} />,
      icon: null,
      content: (
        <span style={{ marginLeft: !message ? 90 : 0 }}>
          {!message ? getMessage('SureToDelete?') : getMessage(message)}
        </span>
      ),
      cancelButtonProps: {
        style: {
          width: 148,
          borderColor: '#EE778F',
          color: '#EE778F'
        },
        type: 'ghost'
      },
      okButtonProps: {
        className: 'button-action',
        type: 'primary',
        style: {
          marginRight: 20
        }
      },
      okText: getMessage('label.yes'),
      cancelText: getMessage('label.no'),
      onOk() {
        if (onDeleteFunc) {
          onDeleteFunc()
        }
      },
      onCancel() {}
    })
  }

  function renderModalLocation() {
    return (
      <>
        <Modal
          title={getMessage('createLocalAndContact')}
          footer={null}
          destroyOnClose={() => {
            setIsModalLocationPlainVisible(false)
            this.locationId = null
          }}
          onCancel={() => {
            setIsModalLocationPlainVisible(false)
            this.locationId = null
          }}
          width="70%"
          visible={isModalLocationPlainVisible}
        >
          <ModalActionPlan
            visible={isModalLocationPlainVisible}
            customer={customer}
            locationId={locationId}
            setLoadCard={setLoadCard}
            loadCard={loadCard}
            setIsModalLocationPlainVisible={setModalVisible}
            idSafra={filters.idSafra}
            onCancel={() => {
              setIsModalLocationPlainVisible(false)
            }}
          />
        </Modal>
      </>
    )
  }

  function renderHeader() {
    const leftContents = (
      <React.Fragment>
        <div>
          <h2>
            <b>Planos de Ação</b>
          </h2>
        </div>
      </React.Fragment>
    )
    const rightContents = (
      <React.Fragment>
        <Button icon="pi pi-plus" label="Expandir todas" onClick={expandAll} className="mr-2" />
        <Button icon="pi pi-minus" label="Fechar todas" onClick={collapseAll} />
        {renderModalLocation()}
      </React.Fragment>
    )
    return (
      <>
        <FilterActionPlan />
        <div style={{ textAlign: 'right', paddingRight: '25px' }}>
          {formattedSafraAtual.id
            ? `O período de planejamento das ações vai de ${formattedSafraAtual.actionPlanningPeriodStartDate} até
        ${formattedSafraAtual.actionPlanningPeriodEndDate}`
            : 'Não existe período definido para planejamento nesta safra'}
        </div>
        <Toolbar left={leftContents} right={rightContents} />
      </>
    )
  }

  const onRowExpand = (event) => {
    toast.current.show({
      severity: 'info',
      summary: `${event.data.locationName} expandida.`,
      detail: event.data.locationName,
      life: 3000
    })
  }

  const onRowCollapse = (event) => {
    toast.current.show({
      severity: 'success',
      summary: `${event.data.locationName} fechada.`,
      detail: event.data.locationName,
      life: 3000
    })
  }

  const expandAll = () => {
    let _expandedRows = {}
    eibLocations.forEach((p) => (_expandedRows[`${p.id}`] = true))

    setExpandedRows(_expandedRows)
  }

  const collapseAll = () => {
    setExpandedRows(null)
  }

  const editBodyTemplate = (rowData) => {
    return (
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          textAlign: 'center'
        }}
      >
        <Button
          icon="pi pi-file-pdf"
          className="btn btn-info"
          style={{ display: 'flex', justifyContent: 'center', height: 30, width: 30, lineHeight: 0.5 }}
          onClick={() => locationActionPlanPdf(rowData)}
        />
        <Button
          icon="pi pi-plus"
          className="btn btn-info"
          disabled={!dentroPeriodo}
          style={{ display: 'flex', justifyContent: 'center', height: 30, width: 30, lineHeight: 0.5 }}
          onClick={() => setModalVisible(true, rowData.id)}
        />
      </div>
    )
  }

  const renderClassificationAction = (rowData) => {
    let cor = '#000000'
    if (rowData.acaoClassificacao > rowData.eibClassificacao) {
      cor = '#FF0000'
    }
    return (
      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <label style={{ marginRight: 10, color: cor }}>
          <Icon type="star" style={{ color: cor, fontSize: 20 }} />
          {rowData.acaoClassificacao}
        </label>
      </div>
    )
  }

  const renderCategoryName = (rowData) => {
    let cor = '#000000'
    if (rowData.acaoClassificacao > rowData.eibClassificacao) {
      cor = '#FF0000'
    }
    return <div style={{ color: cor }}>{rowData.categoriaNome}</div>
  }

  const renderActionName = (rowData) => {
    let cor = '#000000'
    if (rowData.acaoClassificacao > rowData.eibClassificacao) {
      cor = '#FF0000'
    }
    return <div style={{ color: cor }}>{rowData.acaoNome}</div>
  }

  const deletedBodyTemplate = (rowData) => {
    return (
      <Button
        icon="pi pi-trash"
        className="btn btn-info"
        disabled={!dentroPeriodo}
        style={{ display: 'flex', justifyContent: 'center', height: 30, width: 30, lineHeight: 0.5 }}
        onClick={() =>
          rowData.idStatus.trim() === 'ABERTA'
            ? showConfirm(() => {
                deleteLocationPlain(rowData.id)
                setChange(!change)
              }, 'deleteLocationPlain')
            : showAlertMessage(getMessage('deleteLocationPlainTitle'), getMessage('deleteLocationPlainMessage'))
        }
      />
    )
  }

  const allowExpansion = (rowData) => {
    return rowData.locationsPlain.length > 0
  }

  const statusBodyTemplate = (rowData) => {
    let status = {
      color: '',
      label: ''
    }

    switch (rowData.idStatus.trim()) {
      case 'EXECUTADA':
        status.color = '#BFF3DF'
        status.label = 'EXECUTADA'
        break

      case 'CANCELADA':
        status.color = '#F7BCC8'
        status.label = 'CANCELADA'
        break

      case 'ABERTA':
        status.color = '#C7E4FF'
        status.label = 'EM ABERTO'
        break
      default:
        break
    }

    return (
      <div className="div-list-status-table">
        <div className="tag-status" style={{ backgroundColor: status.color }}>
          {status.label}
        </div>
      </div>
    )
  }

  const planejadaBodyTemplate = (rowData) => {
    let color = ''
    let label = ''
    if (rowData.planejada) {
      color = '#C7E4FF'
      label = 'PLANEJADA'
    } else {
      color = '#D6DAE0'
      label = 'NÃO PLANEJADA'
    }

    return (
      <div className="div-list-status-table">
        <div className="tag-status" style={{ backgroundColor: color }}>
          {label}
        </div>
      </div>
    )
  }

  const rowExpansionTemplate = (data) => {
    return (
      <div className="p-3">
        <DataTable value={data.locationsPlain} responsiveLayout="scroll">
          <Column field="categoriaNome" header="Categoria" sortable body={renderCategoryName} />
          <Column field="acaoNome" header="Nome da Ação" sortable body={renderActionName} />
          <Column
            field="acaoClassificacao"
            header="Classificação Impulso Bayer"
            sortable
            body={renderClassificationAction}
          />
          <Column field="planejada" header="Planejamento" sortable body={planejadaBodyTemplate} />
          <Column field="idStatus" header="Execução" sortable body={statusBodyTemplate} />
          <Column header="Ação" body={deletedBodyTemplate} />
        </DataTable>
      </div>
    )
  }

  return (
    <div className="card">
      {renderHeader()}
      <Toast ref={toast} />
      <DataTable
        value={eibLocations}
        expandedRows={expandedRows}
        onRowToggle={(e) => setExpandedRows(e.data)}
        onRowExpand={onRowExpand}
        onRowCollapse={onRowCollapse}
        responsiveLayout="scroll"
        rowExpansionTemplate={rowExpansionTemplate}
        dataKey="id"
      >
        <Column expander={allowExpansion} style={{ width: '3em' }} />
        <Column field="locationName" header="Local" sortable style={{ minWidth: '30%' }} />
        <Column field="planned" header="Planejadas" sortable style={{ maxWidth: '5%', textAlign: 'end' }} />
        <Column field="executed" header="Executadas" sortable style={{ maxWidth: '5%', textAlign: 'end' }} />
        <Column field="totalArea" header="Área Total" sortable style={{ maxWidth: '5%', textAlign: 'end' }} />
        <Column field="regionName" header="Região" sortable style={{ minWidth: '25%' }} />
        <Column field="districtName" header="Distrito" sortable style={{ minWidth: '25%' }} />
        <Column header="Editar" body={editBodyTemplate} style={{ minWidth: '5%' }} />
      </DataTable>
    </div>
  )
}

export default ListActionPlain
